import { Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleRoute from "./components/RoleRoute";
import AppShell from "./components/AppShell";
import Login from "./scenes/login";
import MarketingPage from "./marketing/MarketingPage";
import DashboardEntry from "./components/DashboardEntry";
import Users from "./scenes/users";
import Invoices from "./scenes/invoices";
import DesignLibrary from "./scenes/designLibrary";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Brands from "./scenes/brands";
import Calendar from "./scenes/calendar/calendar";
import BrandLayouts from "./scenes/layouts/BrandLayouts";
import LayoutEditor from "./scenes/layouts/LayoutEditor";
import Unauthorized from "./scenes/unauthorized";
import Settings from "./scenes/settings";
import ChatbotSettings from "./scenes/chatbotSettings";

function App() {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<MarketingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<DashboardEntry />} />
            <Route
              path="/users"
              element={
                <RoleRoute allowedRoles={["admin"]}>
                  <Users />
                </RoleRoute>
              }
            />
            <Route
              path="/contacts"
              element={
                <RoleRoute allowedRoles={["admin"]}>
                  <Contacts />
                </RoleRoute>
              }
            />
            <Route
              path="/invoices"
              element={
                <RoleRoute allowedRoles={["admin"]}>
                  <Invoices />
                </RoleRoute>
              }
            />
            <Route
              path="/backgrounds"
              element={
                <RoleRoute allowedRoles={["admin"]}>
                  <DesignLibrary />
                </RoleRoute>
              }
            />
            <Route
              path="/form"
              element={
                <RoleRoute allowedRoles={["admin", "manager"]}>
                  <Form />
                </RoleRoute>
              }
            />
            <Route
              path="/form/:brandId"
              element={
                <RoleRoute allowedRoles={["admin", "manager"]}>
                  <Form />
                </RoleRoute>
              }
            />
            <Route
              path="/bar"
              element={
                <RoleRoute allowedRoles={["admin"]}>
                  <Bar />
                </RoleRoute>
              }
            />
            <Route
              path="/pie"
              element={
                <RoleRoute allowedRoles={["admin"]}>
                  <Pie />
                </RoleRoute>
              }
            />
            <Route
              path="/line"
              element={
                <RoleRoute allowedRoles={["admin"]}>
                  <Line />
                </RoleRoute>
              }
            />
            <Route
              path="/brands"
              element={
                <RoleRoute allowedRoles={["admin", "designer"]}>
                  <Brands />
                </RoleRoute>
              }
            />
            <Route
              path="/brands/:brandId/layouts"
              element={
                <RoleRoute allowedRoles={["admin", "designer"]}>
                  <BrandLayouts />
                </RoleRoute>
              }
            />
            <Route
              path="/brands/:brandId/editor"
              element={
                <RoleRoute allowedRoles={["admin", "designer"]}>
                  <LayoutEditor />
                </RoleRoute>
              }
            />
            <Route
              path="/brands/:brandId/editor/:layoutId"
              element={
                <RoleRoute allowedRoles={["admin", "designer"]}>
                  <LayoutEditor />
                </RoleRoute>
              }
            />
            <Route
              path="/calendar"
              element={
                <RoleRoute allowedRoles={["admin"]}>
                  <Calendar />
                </RoleRoute>
              }
            />
            <Route path="/settings" element={<Settings />} />
            <Route
              path="/chatbot-settings"
              element={
                <RoleRoute allowedRoles={["admin"]}>
                  <ChatbotSettings />
                </RoleRoute>
              }
            />
            <Route path="/faq" element={<Navigate to="/dashboard" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
